import axios from 'axios';
import { TMCoordinate } from '../MapManager'
const APIURL = '/api';

export const getFieldInfoAPI = (center: TMCoordinate) => {
  return axios.post(`${APIURL}/GetFieldInfoAtPoint`, {
    ...center,
  });
}
